import { createPriceAdjustmentHandler, pricedRowsForLine } from "./priceAdjustment";

/**
 * G6 — Tiered Bundle Pricing (type "TBP"). Each X-product row is a bundle:
 *   quantity = units in the bundle, price = price of the whole bundle.
 * Units are filled into the largest bundles first, then the next size down; units that fill no
 * bundle are charged the regular price. E.g. bundles 3 for ₹120 and 6 for ₹210 (MRP ₹50):
 *   qty 10 = 1 × 210 + 1 × 120 + 1 × 50 = ₹380.
 * A row with quantity 1 acts as a unit price for the leftover units.
 * Returns null when no bundle is reached or the result is not cheaper than the regular price.
 */
export const resolveTieredBundleTotal = (pricingRule, line, qty, realPrice) => {
  const minQty = Number(pricingRule.minimumQty) > 0 ? Number(pricingRule.minimumQty) : 0;
  if (!(qty > 0) || qty < minQty) return null;

  // Cheapest price per bundle size, largest size first.
  const bySize = new Map();
  pricedRowsForLine(pricingRule, line).forEach((row) => {
    const size = Number(row.quantity) > 0 ? Number(row.quantity) : 1;
    const price = Number(row.price);
    if (!bySize.has(size) || price < bySize.get(size)) bySize.set(size, price);
  });
  const sizes = [...bySize.keys()].sort((a, b) => b - a);
  if (sizes.length === 0 || sizes[sizes.length - 1] > qty) return null;

  let remaining = qty;
  let total = 0;
  sizes.forEach((size) => {
    const count = Math.floor(remaining / size);
    if (count > 0) {
      total += count * bySize.get(size);
      remaining -= count * size;
    }
  });
  total += remaining * realPrice;

  if (!(total >= 0) || total >= realPrice * qty) return null;
  return total;
};

export const tieredBundlePricing = createPriceAdjustmentHandler(resolveTieredBundleTotal);
